import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGroupArrowCollapse = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 19,
	viewBox: "0 0 20 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_168_4)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M15.2812 4.82422C15.5352 5.05273 15.5352 5.45898 15.3066 5.6875C15.0781 5.94141 14.6719 5.94141 14.4434 5.71289L9.97461 1.44727L5.53125 5.71289C5.30273 5.94141 4.89648 5.94141 4.66797 5.6875C4.43945 5.45898 4.43945 5.05273 4.69336 4.82422L9.56836 0.152344C9.69531 0.0507812 9.84766 0 9.97461 0C10.127 0 10.2793 0.0507812 10.4062 0.152344L15.2812 4.82422Z",
					fill: "#78909C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M4 10.0312C4 10.4455 4.33579 10.7812 4.75 10.7812H15.25C15.6642 10.7812 16 10.4455 16 10.0312C16 9.61704 15.6642 9.28125 15.25 9.28125H4.75C4.33579 9.28125 4 9.61704 4 10.0312Z",
					fill: "#78909C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.9468 5.19587L14.9409 5.19063L14.9353 5.18521L10.0812 0.533402C10.0476 0.510464 10.0107 0.5 9.97461 0.5C9.9757 0.5 9.96366 0.500237 9.94236 0.507982C9.92632 0.513812 9.90946 0.522326 9.89347 0.533314L5.03931 5.18521L5.03366 5.19063L5.02784 5.19587C5.01332 5.20894 5.00034 5.23185 4.99966 5.26586C4.99894 5.30185 5.01254 5.32496 5.02152 5.33395L5.03082 5.34324L5.03962 5.35302C5.05269 5.36754 5.0756 5.38052 5.10961 5.3812C5.1456 5.38192 5.16871 5.36832 5.1777 5.35934L5.17762 5.35926L5.18498 5.3522L9.62834 1.08657L9.97362 0.755102L10.3198 1.08559L14.7886 5.35121L14.7887 5.35112L14.7969 5.35934C14.8059 5.36832 14.829 5.38192 14.865 5.3812C14.899 5.38052 14.9219 5.36754 14.935 5.35302L14.9438 5.34324L14.9531 5.33395C14.9621 5.32496 14.9757 5.30185 14.975 5.26586C14.9743 5.23185 14.9613 5.20894 14.9468 5.19587ZM4.75 10.2812H15.25C15.3881 10.2812 15.5 10.1693 15.5 10.0312C15.5 9.89318 15.3881 9.78125 15.25 9.78125H4.75C4.61193 9.78125 4.5 9.89318 4.5 10.0312C4.5 10.1693 4.61193 10.2812 4.75 10.2812Z",
					stroke: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.9468 5.19587L14.9409 5.19063L14.9353 5.18521L10.0812 0.533402C10.0476 0.510464 10.0107 0.5 9.97461 0.5C9.9757 0.5 9.96366 0.500237 9.94236 0.507982C9.92632 0.513812 9.90946 0.522326 9.89347 0.533314L5.03931 5.18521L5.03366 5.19063L5.02784 5.19587C5.01332 5.20894 5.00034 5.23185 4.99966 5.26586C4.99894 5.30185 5.01254 5.32496 5.02152 5.33395L5.03082 5.34324L5.03962 5.35302C5.05269 5.36754 5.0756 5.38052 5.10961 5.3812C5.1456 5.38192 5.16871 5.36832 5.1777 5.35934L5.17762 5.35926L5.18498 5.3522L9.62834 1.08657L9.97362 0.755102L10.3198 1.08559L14.7886 5.35121L14.7887 5.35112L14.7969 5.35934C14.8059 5.36832 14.829 5.38192 14.865 5.3812C14.899 5.38052 14.9219 5.36754 14.935 5.35302L14.9438 5.34324L14.9531 5.33395C14.9621 5.32496 14.9757 5.30185 14.975 5.26586C14.9743 5.23185 14.9613 5.20894 14.9468 5.19587ZM4.75 10.2812H15.25C15.3881 10.2812 15.5 10.1693 15.5 10.0312C15.5 9.89318 15.3881 9.78125 15.25 9.78125H4.75C4.61193 9.78125 4.5 9.89318 4.5 10.0312C4.5 10.1693 4.61193 10.2812 4.75 10.2812Z",
					stroke: "black",
					strokeOpacity: .2
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_168_4",
			x: 0,
			y: 0,
			width: 20,
			height: 18.7812,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_168_4"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_168_4",
					result: "shape"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgGroupArrowCollapse);
export { ForwardRef as ReactComponent };
